// import Honeybadger from 'honeybadger-js';
import { WEBFLOW_SCRIPT_ENV } from '../src/webflow-script-env';
import { clonePlaceOrderButton } from './clonePlaceOrderButton';
import { devEvnFormFill } from './devEnvFormFill';
import { getCheckoutFormValidity } from './getCheckoutFormValidity';
import { getFinishCheckoutObserver } from './getFinishCheckoutObserver';
import { getOnlyElementByAttribute } from './getOnlyElementByAttribute';
import { prepareCheckoutUpsellStyles } from './prepareCheckoutUpsellStyles';
import { setCheckoutUpsellErrorStateObserver } from './setCheckoutUpsellErrorStateObserver';
import { shouldShowCheckoutUpsell } from './shouldShowCheckoutUpsell';
import { simulateClick } from './simulateClick';
import { storeCartSKUs } from './storeCartSKUs';
import { storeCheckoutUpsellMap } from './storeCheckoutUpsellMap';
import { upsellElements } from './upsellElements';

export const checkoutUpsells = (checkoutDiv: HTMLElement) => {
  let intervalCount = 0;

  const loadUpsell = setInterval(async () => {
    try {
      const {
        cartModal,
        cartWrapper,
        closeUpsellArray,
        openUpsellArray,
      } = upsellElements();
      intervalCount++;

      const { cartSKUs } = storeCartSKUs();

      const sku = cartSKUs[0];

      //TODO: have better logic for determining SKU

      if (
        sku &&
        cartModal &&
        cartWrapper &&
        openUpsellArray &&
        openUpsellArray[0] &&
        closeUpsellArray &&
        closeUpsellArray[0]
      ) {
        clearInterval(loadUpsell);

        // fetch and save upsells
        const { upsellData } = await storeCheckoutUpsellMap(cartSKUs);

        // determine which upsell here

        // eventually could push this to the upsell lambda
        // determine which upsell here

        const {
          showUpsell,
          upsellProductId,
          upsellSKUs,
        } = shouldShowCheckoutUpsell(upsellData, cartSKUs);

        if (upsellProductId && upsellSKUs && upsellSKUs[0] && showUpsell) {
          const stylesSet = prepareCheckoutUpsellStyles(upsellProductId);

          //TODO: need to clean up attributes here
          const {
            placeOrderButton,
            placeOrderButtonClone,
          } = clonePlaceOrderButton(checkoutDiv);

          const showUpsell = (evt: MouseEvent): void => {
            //Check form validity

            const { checkoutFormValidity } = getCheckoutFormValidity();

            //Check for validity
            if (checkoutFormValidity) {
              const target = (evt.target as unknown) as HTMLElement;

              target.removeEventListener('click', showUpsell);

              const errorState = getOnlyElementByAttribute(
                '[data-node-type="commerce-checkout-error-state"]'
              ) as HTMLElement;

              const {
                errorStateObserver,
              } = setCheckoutUpsellErrorStateObserver();

              const finishCheckoutObserver = getFinishCheckoutObserver(
                upsellSKUs
              );

              if (finishCheckoutObserver && errorStateObserver) {
                finishCheckoutObserver.observe(cartWrapper, {
                  attributes: true,
                  childList: true,
                  subtree: true,
                });
                errorStateObserver.observe(errorState, {
                  attributes: true,
                  childList: true,
                  subtree: true,
                });

                simulateClick(openUpsellArray[0]);

                const finishCheckout = () => {
                  simulateClick(placeOrderButton);
                };

                //Handle upsell rejection cleanup
                const { closeUpsellArray } = upsellElements();

                closeUpsellArray.forEach((element) => {
                  element.addEventListener('click', finishCheckout);
                });
              }
            }
          };

          if (placeOrderButton && placeOrderButtonClone && stylesSet)
            if (
              WEBFLOW_SCRIPT_ENV === 'dev' ||
              WEBFLOW_SCRIPT_ENV === 'staging'
            ) {
              // /* Inputs (only necessary for demo) */
              devEvnFormFill();
            }
          placeOrderButtonClone.addEventListener('click', showUpsell);
        }
      }

      if (intervalCount > 50) clearInterval(loadUpsell);
    } catch (error) {
      clearInterval(loadUpsell);
      throw error;
    }
  }, 50);
};
